
  import ScreenSize from '@/mixins/ScreenSize';
  import Events from '@/events/Events';
  import DialogsBaseSection from '@/components/sections/DialogsBaseSection.vue';
  import {prepareImageUrl} from '@/helper/ImageHelper';
  import JobBoxSimilarOffers from '@/components/elements/JobBoxSimilarOffers';
  import ProfileIncomplete from '@/mixins/ProfileIncomplete';
  import ShareIcons from '@/components/ShareIcons';
  import LazyHydrate from 'vue-lazy-hydration';

  export default {
    name: 'ThankYouPage',
    components: {
      RichText: () => import('@/components/elements/RichText'),
      DialogsBaseSection,
      JobBoxSimilarOffers,
      ProfileIncompleteButton: () =>
        import('@/components/elements/ProfileIncompleteButton'),
      ShareIcons,
      LazyHydrate,
    },
    mixins: [ProfileIncomplete, ScreenSize],
    props: {
      job: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        section: {},
        tracking_script_included: false,
        imageUrl: '',
      };
    },
    async fetch() {
      this.section = await this.$cachedStrapi
        .find('application-success-dialog')
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });
    },
    created() {
      if (this.section.image) {
        this.imageUrl = prepareImageUrl(this.section.image.url);
      }
    },
    methods: {
      closeDialog() {
        this.$emit('close-dialog');
        this.$emitWithClientData(Events.ThankYouPageClosed, {
          type: 'JobApplication',
        });
      },
    },
  };
